import type { PropsWithChildren } from "react";
import type { ReportType } from "../../../../../api/types/svTypes";
import { SupportedReportTypesContext } from "./SupportedReportTypesContext";

interface Props {
  supportedReportTypes: ReportType[];
}

export const SupportedReportTypesContextProvider = ({ children, supportedReportTypes }: PropsWithChildren<Props>) => {
  return <SupportedReportTypesContext value={{ supportedReportTypes }}>{children}</SupportedReportTypesContext>;
};
